enum DeviceType {
  Plug = 'plug',
  Light = 'light',
  WiFiSwitch = 'wifiSwitch',
}

export default DeviceType;



// WEBPACK FOOTER //
// ./src/enums/DeviceType.ts